import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { useGetCampaign } from '@urbanx/agx.campaigns.client';
import type { TaskModalContentConfig } from 'pages/allTasks/TaskModal/TaskModalDialog';
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps';
import ExchangeTaskPage from './ExchangeTaskPage';
import { getExchangeTaskDocumentGroups } from './exchangeTaskDocuments';
import { useExchangeTaskForm } from './useExchangeTaskForm';

interface UseExchangeTaskModalProps {
  campaignId: string;
  isOpen: boolean;
  tasks: AutopilotTaskDto[];
}

export const useExchangeTaskModal = ({ campaignId, isOpen, tasks }: UseExchangeTaskModalProps) => {
  const contractId = tasks[0]?.contractId;
  const firstIncompleteTaskIndex = tasks.findIndex((task) => task.isCompleted !== true);
  const initialPageIndex = firstIncompleteTaskIndex >= 0 ? firstIncompleteTaskIndex : 0;
  const { data: campaign, isPending: isCampaignPending } = useGetCampaign(campaignId, !!campaignId);
  const selectedContract = campaign?.contractDetails?.find(
    (contract) => contract.contractId === contractId
  );

  const exchangeForm = useExchangeTaskForm(campaignId, contractId, isOpen);

  const renderPage = (props: TaskModalPageProps) => (
    <ExchangeTaskPage {...props} exchangeForm={exchangeForm} />
  );

  const contentConfig: TaskModalContentConfig = {
    documents: getExchangeTaskDocumentGroups(selectedContract),
    isPending: isCampaignPending || exchangeForm.isPending,
    initialPageIndex,
    hideTaskMetadata: true,
    hideCloseButton: true,
    presentationClassName: 'taskModal--exchange',
    onSaveAllPages: (modalTasks) =>
      exchangeForm.saveTasks(modalTasks.map((task) => task.category?.taskType)),
    renderPage,
  };

  return {
    campaign,
    contentConfig,
  };
};
